import { Component, Input } from '@angular/core';
import type { CommerceSolar, TrackedProductComponent } from '@analytics/models';
import { componentViewModelSelector } from '@core/experience-editor-utils';
import type { SolarPanelsProductWithCalculations } from '@innogy/feh/temporary-core-modules';
import { getFieldValue } from '@core/jss-utils';
import { Store } from '@ngrx/store';

import {
  selectSolarPanelsResultOverviewViewModal,
  SolarPanelsProductTrackingConfig,
} from '../../store';
import type { SolarPanelsResultOverviewSummaryComponentFields } from '../../models/solar-panels-result-overview-summary-rendering.interface';
import { SolarPanelsResultOverviewSummaryRendering } from '../../models/solar-panels-result-overview-summary-rendering.interface';
import { mockSolarPanelsResultOverviewViewModel } from '../solar-panels-result-overview-container/solar-panels-result-overview-container.component.xp.mock';

@Component({
  selector: 'wl-solar-panels-result-overview-summary-container[rendering]',
  styleUrls: [
    './solar-panels-result-overview-summary-container.component.essent.scss',
    './solar-panels-result-overview-summary-container.component.ed.scss',
  ],
  templateUrl:
    './solar-panels-result-overview-summary-container.component.html',
})
export class SolarPanelsResultOverviewSummaryContainerComponent
  implements
    TrackedProductComponent<SolarPanelsProductWithCalculations, CommerceSolar>
{
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering!: SolarPanelsResultOverviewSummaryRendering;

  trackProductConfig = this.trackingConfig.config;

  readonly viewModel$ = this.store$.select(
    componentViewModelSelector(
      selectSolarPanelsResultOverviewViewModal,
      mockSolarPanelsResultOverviewViewModel
    )
  );

  constructor(
    private readonly store$: Store,
    private readonly trackingConfig: SolarPanelsProductTrackingConfig
  ) {}

  get fields(): SolarPanelsResultOverviewSummaryComponentFields {
    return this.rendering.fields;
  }

  get isPlacedOnOrderPage() {
    return getFieldValue<boolean>(this.rendering, 'IsPlacedOnOrderPage', false);
  }

  get trackMode(): 'product-impression' | 'product-detail' {
    return this.isPlacedOnOrderPage ? 'product-detail' : 'product-impression';
  }

  get maximumAmountOfPanelsTooltip() {
    const description = getFieldValue<string>(
      this.rendering,
      'MaximumAmountOfPanelsTooltip'
    );

    return { description };
  }

  get recommendedAmountOfPanelsTooltip() {
    const description = getFieldValue<string>(
      this.rendering,
      'RecommendedAmountOfPanelsTooltip'
    );

    return { description };
  }

  get savingsPerYearTooltip() {
    const description = getFieldValue<string>(
      this.rendering,
      'SavingsPerYearTooltip'
    );

    return { description };
  }
}
